import React from "react";
import { Helmet } from "react-helmet";
import './classes/SmwwNewsPage.css';

// A conference speaker at its own address (live's "content/<slug>" alias, or node/<id>), which
// Page.js shows when no page has that address; Manage Conference Speakers links its titles here.
// As live's node page: none of the speaker's fields, the speaker's title as the browser title, and
// the View / Edit tabs for admins.
const ConferenceSpeakerPage = ({ speaker, isAdmin }) => (
    <div id="main" className="smww-news-page node-type-conference-speakers">
        <Helmet><title>{speaker.title}</title></Helmet>
        <div className="left"></div>
        <div className="center left-center">
            {isAdmin && (
                <ul className="tabs primarya">
                    <li className="active"><a href={speaker.link}>View</a></li>
                    <li><a href={"/conference-speakers/" + speaker.id + "/edit"}>Edit</a></li>
                </ul>
            )}
            <div id={"node-" + speaker.id} className="node node-conference-speakers node-promoted">
                <div className="content clearfix"></div>
            </div>
        </div>
        <div className="right"></div>
    </div>
);

export default ConferenceSpeakerPage;
